// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"8d51f45433286a7314bf","245":"238e84d9bc173d62c3de","452":"1bb1924a8a5bb313265e","453":"8be73b23c552e4290935"}[chunkId] + ".js";
};